import React from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';

const OPERATORS = [
    { value: 'EQUAL_TO', label: 'EQUAL_TO' },
    { value: 'NOT_EQUAL_TO', label: 'NOT_EQUAL_TO' },
    { value: 'GREATER_THAN', label: 'GREATER_THAN' },
    { value: 'LESS_THAN', label: 'LESS_THAN' },
    { value: 'GREATER_THAN_EQUAL_TO', label: 'GREATER_THAN_EQUAL_TO' },
    { value: 'LESS_THAN_EQUAL_TO', label: 'LESS_THAN_EQUAL_TO' },
    { value: 'INCLUDES', label: 'INCLUDES' },
    { value: 'NOT_INCLUDES', label: 'NOT_INCLUDES' },
    { value: 'STARTS_WITH', label: 'STARTS_WITH' },
    { value: 'ENDS_WITH', label: 'ENDS_WITH' },
    { value: 'CONTAINS', label: 'CONTAINS' },
    { value: 'NOT_CONTAINS', label: 'NOT_CONTAINS' }
];

const UpdateConditionForm = ({ formData, setFormData, requestParameters }) => {
    return (
        <Form.Group className="mt-3">
            <Form.Label>Update Condition</Form.Label>
            <div className="d-flex align-items-end gap-2">
                <div className="flex-grow-1">
                    <Form.Label className="small text-muted">Field</Form.Label>
                    <Select
                        options={requestParameters}
                        value={requestParameters.find(param => param.value === formData?.conditionField?.value)}
                        onChange={(selected) => {
                            setFormData(prev => ({
                                ...prev,
                                conditionField: selected || '',
                                condition: prev.condition || ''
                            }));
                        }}
                        placeholder="Select Field"
                    />
                </div>
                <div style={{ width: '200px' }}>
                    <Form.Label className="small text-muted">Operator</Form.Label>
                    <Select
                        options={OPERATORS}
                        value={OPERATORS.find(op => op.value === formData?.conditionOperator)}
                        onChange={(selected) => {
                            setFormData(prev => ({
                                ...prev,
                                conditionOperator: selected?.value || '',
                                condition: prev.condition || ''
                            }));
                        }}
                        placeholder="Select Operator"
                    />
                </div>
                <div className="flex-grow-1">
                    <Form.Label className="small text-muted">Value</Form.Label>
                    <Form.Control
                        type="text"
                        value={formData?.conditionValue || ''}
                        onChange={(e) => {
                            setFormData(prev => ({
                                ...prev,
                                conditionValue: e.target.value,
                                condition: prev.condition || ''
                            }));
                        }}
                        placeholder="Enter Value"
                    />
                </div>
            </div>
        </Form.Group>
    );
};

export default UpdateConditionForm; 